import {Permissao} from "@/core/models/index.js";
import PermissaoRecurso from "@/core/models/PermissaoRecurso.js";

/**
 * @property {int} id
 * @property {string} nome
 * @property {string} email
 * @property {string} avatar
 * @property {string} hmac
 * @property {int} org_id
 * @property {string} org_nome
 * @property {string} org_cidade
 * @property {string} org_estado
 * @property {string} org_avatar
 * @property {Permissao} permissao
 */
export default class UserInfo {
    id;
    nome;
    email;
    avatar;
    hmac;
    org_id;
    org_nome;
    org_cidade;
    org_estado;
    org_avatar;
    permissao;
    tipo_usuario;

    /**
     *
     * @param {int} id
     * @param {string} nome
     * @param {string} email
     * @param {string} foto
     * @param {string} hmac
     * @param {{id, nome, logo, cidade, estado: {sigla}}} cliente
     * @param Object permissao
     */
    constructor(
        id = 0,
        nome = '',
        email = '',
        foto = '',
        hash='',
        cliente = {},
        acesso = {}
    ) {
        this.id = id;
        this.nome = nome;
        this.email = email;
        this.avatar = foto;
        this.hmac = hash;
        this.org_id = cliente?.id || 0;
        this.org_nome = cliente?.nome || '';
        this.org_estado = cliente?.estado?.sigla || '';
        this.org_cidade = cliente?.cidade || '';
        this.org_avatar = cliente?.logo || '';

        this.tipo_usuario = acesso?.tipo_usuario || 'USUARIO_COMUM'
        this.acesso = acesso || {}

        this.permissao = this.parsePermissao(
            acesso?.permissoes || {}
        )
    }

    /**
     *
     * @param Object permissao
     * @returns {Permissao}
     */
    parsePermissao(permissao) {
        /*
        {
                "visualizar_encontros": true,
                "criar_encontros": true,
                "registrar_encontros": true,
                "filtrar_por_educador": true
            }
         */
        const p = new Permissao('pwa', 'encontros');
        p.adicionarRecurso(new PermissaoRecurso(
            1,
            'Encontros',
            '',
            'encontros',
            permissao.visualizar_encontros,
            permissao.criar_encontros,
            permissao.registrar_encontros,
            false
        ));
        p.adicionarRecurso(new PermissaoRecurso(
            2,
            'Filtros por educador',
            '',
            'filtro_educador',
            permissao.filtrar_por_educador,
            false,
            false,
            false
        ))
        return p
    }
}